<template>
  <div>
    <a class="interactive" :class="classes" @click="handleClick">
      {{ label }}
    </a>
  </div>
</template>

<script>
export default {
  props: {
    classes: {
      type: String,
      required: false,
      default: "button tertiary",
    },
    label: {
      type: String,
      required: false,
      default: "Enquire Now",
    },
  },
  methods: {
    handleClick() {
      if (!this.$store.getters["user/account"]) {
        return this.$store.commit("user/changeAuthMode", "login");
      }
      //   if (!window.location.href.includes("#list-your-space-today")) {
      //     window.history.pushState(
      //       "state obj or string",
      //       "url",
      //       window.location.href + "#list-your-space-today"
      //     );
      //   }
      // if (!this.$store.getters['user/account']) {
      //   return this.$store.commit('user/changeAuthMode', 'signup')
      // }
      this.$store.dispatch("modals/showByronEnquire");
    },
  },
};
</script>
